import * as React from 'react';

import useModalAccessiblity from '../../Shared/hooks/useModalAccessibility'
import PremiumFeaturesColumn from '../components/premium/premium_features_column';
import StripeSubscriptionCheckoutSessionButton from '../components/shared/StripeSubscriptionCheckoutSessionButton';

const AlreadyHasPremiumModal = ({ close, }) => {
  const { modalRef, } = useModalAccessiblity(close)

  return (
    <div className="modal-container already-has-premium-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="alreadyHasPremiumModalTitle"
        aria-modal="true"
        className="already-has-premium-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          <h3 className="title" id="alreadyHasPremiumModalTitle">You already have a Premium subscription.</h3>
        </div>
        <p>Please visit the <a className="focus-on-light" href="/subscriptions">My Subscriptions</a> page  to learn more.</p>
        <div className="form-buttons">
          <button className="quill-button medium contained green focus-on-light" onClick={close} type="button">OK</button>
        </div>
      </div>
    </div>
  )
}

const LoginToPurchaseModal = ({ close }) => {
  const { modalRef, } = useModalAccessiblity(close)

  return (
    <div className="modal-container log-in-to-purchase-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="loginToPurchaseModalTitle"
        aria-modal="true"
        className="login-to-purchase-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          <h3 className="title" id="loginToPurchaseModalTitle">Log in to purchase</h3>
        </div>
        <p>Please <a className="focus-on-light" href="/session/new">log in to your Quill account</a> to purchase Teacher Premium.</p>
        <div className="form-buttons">
          <button className="quill-button medium contained green focus-on-light" onClick={close} type="button">OK</button>
        </div>
      </div>
    </div>
  )
}

export const TeacherPremium = ({
  customerEmail,
  stripeTeacherPlan,
  userIsEligibleForNewSubscription,
}) => {
  const [showAlreadyHasPremiumModal, setShowAlreadyHasPremiumModal] = React.useState(false)
  const [showLoginToPurchaseModal, setShowLoginToPurchaseModal] = React.useState(false)

  const userIsSignedIn = () => {
    return !!customerEmail
  }

  function closeAlreadyHasPremiumModal() { setShowAlreadyHasPremiumModal(false) }

  function openAlreadyHasPremiumModal() { setShowAlreadyHasPremiumModal(true) }

  function toggleLoginToPurchaseModal() { setShowLoginToPurchaseModal(!showLoginToPurchaseModal) }

  const teacherBuyNowButton = () => {
    if(!customerEmail) {
      return <button className="quill-button contained medium gold focus-on-light" onClick={toggleLoginToPurchaseModal} type="button">Buy now</button>
    } else if (!userIsEligibleForNewSubscription) {
      return <button className="quill-button contained medium gold focus-on-light" onClick={openAlreadyHasPremiumModal} type="button">Buy now</button>
    }
    return (
      <StripeSubscriptionCheckoutSessionButton
        buttonClassName="quill-button contained medium gold focus-on-light"
        buttonId="purchase-btn"
        buttonText='Buy now'
        cancelPath='premium'
        customerEmail={customerEmail}
        stripePriceId={stripeTeacherPlan.plan.stripe_price_id}
        userIsEligibleForNewSubscription={userIsEligibleForNewSubscription}
        userIsSignedIn={userIsSignedIn()}
      />
    )
  }

  const testimonials = (
    <section className="premium-page-section">
      <h3 className="premium-page-section-header">What are people saying?</h3>
      <div className="premium-features-row testimonials-wrapper">
        <div className="testimonial long">
          <p>I absolutely LOVE Quill! I love it so much that I pay for the premium account on my own because I know what an incredible resource it is for students and teachers!</p>
          <span>T. Parsons, ELA Teacher, M.S.D. of Wayne Township, IN</span>
        </div>
        <div className="testimonial">
          <p>I love the pre & post test data. My data-keen admin loves seeing that.</p>
          <span>C. Matthews, ELA Teacher, Haywood County Schools, NC</span>
        </div>
        <div className="testimonial full-width">
          <p>Quill has been an amazing investment and a great tool in my 9th grade classroom. Students are engaged with the independent and class lessons, and are truly taking an interest learning writing and grammar conventions. I love quill, but most importantly, my students love being able to decode and find the mistakes; the inner competition is truly engaging!</p>
          <span>D. Riddick, ELA Teacher, Waterbury Public Schools, CT</span>
        </div>
      </div>
    </section>
  )

  return (
    <div className="container premium-page teacher-premium-page">
      {showAlreadyHasPremiumModal && <AlreadyHasPremiumModal close={closeAlreadyHasPremiumModal} />}
      {showLoginToPurchaseModal && <LoginToPurchaseModal close={toggleLoginToPurchaseModal} />}
      <h1>Gain deeper insight into student performance <br />with Teacher Premium</h1>
      <p className="page-subheader">Easily view and download Quill Progress Reports to see detailed insights on your students’ skill growth and performance.</p>
      <section className="premium-features-columns-wrapper">
        <PremiumFeaturesColumn
          onTeacherPage={true}
          subheader="Free for Teachers"
          subheaderButton={userIsSignedIn() ? <span className="button-placeholder" /> :<a className="quill-button contained medium green focus-on-dark" href="/account/new">Sign up free</a>}
          subheaderDescription="No contract"
          title="Teacher Basic"
        />
        <PremiumFeaturesColumn
          onTeacherPage={true}
          subheader="$80 Per Teacher, Per Year"
          subheaderButton={teacherBuyNowButton()}
          subheaderDescription="Advanced insights and reporting"
          title="Teacher Premium"
        />
      </section>
      <div className="features">
        {testimonials}
      </div>
    </div>
  )
}

export default TeacherPremium
